module.exports = function () {
    return {
        require: '^^?olyHoverMenu',
        restrict: 'A',
        link: (scope, elem, attr, hoverMenuController) => {
            const hoverMenuAction = params => scope.$eval(attr.olyHoverMenuAction, params);

            if (hoverMenuController) {
                hoverMenuController.registerActionElement(elem, hoverMenuAction);
            }
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/hovermenu/hovermenu-action.directive.js